module.exports = __webpack_public_path__ + "img/easi-premium.e5f18783.svg";